import CooperateManage from '@components/ExperienceShop/CooperateManage'
import CooperateOrderDetail from '@components/ExperienceShop/CooperateOrderDetail'
import CheckBill from '@components/ExperienceShop/CheckBill'
import ExperienceShop from '@components/LocalMerchant/ExperienceShop/List'
import Detail from '@components/LocalMerchant/ExperienceShop/Detail'
import JiaMengHeader from '@components/JiaMeng/Header/Customer'
import React from 'react'

export default [
  {
    path: 'experienceShopManage',
    stat: '体验店合作管理',
    indexRoute: {
      component: CooperateManage
    },
    childRoutes: [
      {
        path: 'detail/:id',
        component: CooperateOrderDetail,
        stat: '体验店合作管理/订单详情'
      },
      {
        path: 'checkBill',
        component: CheckBill,
        stat: ''
      }
    ]
  },
  {
    path: 'experienceShop',
    component: props => <JiaMengHeader key="experienceShop" {...props} />,
    indexRoute: {
      component: ExperienceShop
    },
    stat: '体验店推荐/首页',
    childRoutes: [
      {
        path: 'detail/:id',
        component: Detail,
        stat: '体验店推荐/推荐详情'
      }
    ]
  }
]
